import { render, staticRenderFns } from "./userAdd.vue?vue&type=template&id=ba77c088&"
import script from "./userAdd.vue?vue&type=script&lang=js&"
export * from "./userAdd.vue?vue&type=script&lang=js&"
import style0 from "./userAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports